import { request } from './request';

export const getPatientFeeStructure = (customerId, doctorId, exam) =>
  request(
    `fee_structures?customerId=${customerId}&doctorId=${doctorId}&exam=${exam}`,
  );
